// import { useRef, useState, useEffect } from "react";
// import mapboxgl from "mapbox-gl";
// import "mapbox-gl/dist/mapbox-gl.css";

import { useContext } from "react";
import studyAreaImage from "../components/ui/images/map/valenciaStudyArea.jpg";
import studyAreaImageZoomedOut from "../components/ui/images/map/valenciaStudyAreaZoomedOut.jpg";
import { LanguageContext } from "./languageContext";
// import studyAreaJson from "../lib/geojson/studyArea.json";

// mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || "";

export default function StudyAreaMap() {
  // uncomment these to render the live map
  //
  //   const mapContainer = useRef<HTMLDivElement>(null);
  //   const map = useRef<mapboxgl.Map | null>(null);
  //   const [lng] = useState(-122.421);
  //   const [lat] = useState(37.759);
  //   const [zoom] = useState(13);

  //   useEffect(() => {
  //     if (!mapContainer.current) return;

  //     map.current = new mapboxgl.Map({
  //       container: mapContainer.current,
  //       style: "mapbox://styles/mapbox/light-v11",
  //       center: [lng, lat],
  //       zoom: zoom,
  //     });

  //     map.current.on("load", () => {
  //       if (!map.current) return;

  //       map.current.addSource("study-area", {
  //         type: "geojson",
  //         data: studyAreaJson as GeoJSON.FeatureCollection,
  //       });

  //       map.current.addLayer({
  //         id: "study-area-fill",
  //         type: "fill",
  //         source: "study-area",
  //         filter: ["==", ["get", "name"], "Study Area"],
  //         paint: {
  //           "fill-opacity": 0,
  //         },
  //       });

  //       map.current.addLayer({
  //         id: "study-area-line",
  //         type: "line",
  //         source: "study-area",
  //         filter: ["==", ["get", "name"], "Study Area"],
  //         paint: {
  //           "line-color": "#627BC1",
  //           "line-width": 2,
  //         },
  //       });

  //       map.current.addLayer({
  //         id: "valencia-street",
  //         type: "line",
  //         source: "study-area",
  //         filter: ["==", ["get", "name"], "Valencia Street"],
  //         paint: {
  //           "line-color": "#000000",
  //           "line-width": 15,
  //           "line-opacity": 0.2,
  //         },
  //       });
  //     });

  //     return () => {
  //       map.current?.remove();
  //     };
  //   }, [lng, lat, zoom]);

  const { translate } = useContext(LanguageContext);

  return (
    <div className="flex flex-wrap gap-4">
      <img
        src={studyAreaImage}
        alt={translate("studyAreaMapAlt")}
        className="w-full sm:w-[400px]"
      />
      <div>
        <img
          src={studyAreaImageZoomedOut}
          alt={translate("studyAreaMapAltZoomedOut")}
          className="w-full sm:w-[420px]"
        />
      </div>
      {/* Live map I took screenshots of for the "study area" section, if we want to render it for other screenshots */}
      {/* <div ref={mapContainer} className="h-[500px] w-full" /> */}
    </div>
  );
}
